<template>
  <svg v-if="isFill" xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" :opacity="opacity" :style="{ color: color }" viewBox="0 0 36 36" fill="none">
    <path
      d="M17.001 12.2773C15.7487 12.2773 14.5477 12.7748 13.6622 13.6603C12.7768 14.5458 12.2793 15.7467 12.2793 16.999C12.2793 18.2513 12.7768 19.4522 13.6622 20.3377C14.5477 21.2232 15.7487 21.7207 17.001 21.7207C18.2532 21.7207 19.4542 21.2232 20.3397 20.3377C21.2252 19.4522 21.7226 18.2513 21.7226 16.999C21.7226 15.7467 21.2252 14.5458 20.3397 13.6603C19.4542 12.7748 18.2532 12.2773 17.001 12.2773Z"
      fill="url(#paint0_radial_9975_53677)"
    />
    <path
      d="M17.001 12.2773C15.7487 12.2773 14.5477 12.7748 13.6622 13.6603C12.7768 14.5458 12.2793 15.7467 12.2793 16.999C12.2793 18.2513 12.7768 19.4522 13.6622 20.3377C14.5477 21.2232 15.7487 21.7207 17.001 21.7207C18.2532 21.7207 19.4542 21.2232 20.3397 20.3377C21.2252 19.4522 21.7226 18.2513 21.7226 16.999C21.7226 15.7467 21.2252 14.5458 20.3397 13.6603C19.4542 12.7748 18.2532 12.2773 17.001 12.2773Z"
      fill="url(#paint1_radial_9975_53677)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.3349 2.83594C9.08086 2.83594 6.91911 3.73137 5.32524 5.32524C3.73137 6.91911 2.83594 9.08086 2.83594 11.3349L2.83594 22.6669C2.83594 24.921 3.73137 27.0828 5.32524 28.6766C6.91911 30.2705 9.08086 31.1659 11.3349 31.1659H22.6669C24.921 31.1659 27.0828 30.2705 28.6766 28.6766C30.2705 27.0828 31.1659 24.921 31.1659 22.6669V11.3349C31.1659 9.08086 30.2705 6.91911 28.6766 5.32524C27.0828 3.73137 24.921 2.83594 22.6669 2.83594L11.3349 2.83594ZM10.3906 17.0009C10.3906 15.2478 11.087 13.5664 12.3267 12.3267C13.5664 11.087 15.2478 10.3906 17.0009 10.3906C18.7541 10.3906 20.4355 11.087 21.6751 12.3267C22.9148 13.5664 23.6113 15.2478 23.6113 17.0009C23.6113 18.7541 22.9148 20.4355 21.6751 21.6751C20.4355 22.9148 18.7541 23.6113 17.0009 23.6113C15.2478 23.6113 13.5664 22.9148 12.3267 21.6751C11.087 20.4355 10.3906 18.7541 10.3906 17.0009ZM23.6113 9.44627C23.6113 9.96781 24.0341 10.3906 24.5556 10.3906C25.0771 10.3906 25.4999 9.96781 25.4999 9.44627C25.4999 8.92473 25.0771 8.50194 24.5556 8.50194C24.0341 8.50194 23.6113 8.92473 23.6113 9.44627Z"
      fill="url(#paint2_radial_9975_53677)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.3349 2.83594C9.08086 2.83594 6.91911 3.73137 5.32524 5.32524C3.73137 6.91911 2.83594 9.08086 2.83594 11.3349L2.83594 22.6669C2.83594 24.921 3.73137 27.0828 5.32524 28.6766C6.91911 30.2705 9.08086 31.1659 11.3349 31.1659H22.6669C24.921 31.1659 27.0828 30.2705 28.6766 28.6766C30.2705 27.0828 31.1659 24.921 31.1659 22.6669V11.3349C31.1659 9.08086 30.2705 6.91911 28.6766 5.32524C27.0828 3.73137 24.921 2.83594 22.6669 2.83594L11.3349 2.83594ZM10.3906 17.0009C10.3906 15.2478 11.087 13.5664 12.3267 12.3267C13.5664 11.087 15.2478 10.3906 17.0009 10.3906C18.7541 10.3906 20.4355 11.087 21.6751 12.3267C22.9148 13.5664 23.6113 15.2478 23.6113 17.0009C23.6113 18.7541 22.9148 20.4355 21.6751 21.6751C20.4355 22.9148 18.7541 23.6113 17.0009 23.6113C15.2478 23.6113 13.5664 22.9148 12.3267 21.6751C11.087 20.4355 10.3906 18.7541 10.3906 17.0009ZM23.6113 9.44627C23.6113 9.96781 24.0341 10.3906 24.5556 10.3906C25.0771 10.3906 25.4999 9.96781 25.4999 9.44627C25.4999 8.92473 25.0771 8.50194 24.5556 8.50194C24.0341 8.50194 23.6113 8.92473 23.6113 9.44627Z"
      fill="url(#paint3_radial_9975_53677)"
    />
    <defs>
      <radialGradient id="paint0_radial_9975_53677" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(14.7877 22.448) rotate(-90) scale(9.35904 8.70465)">
        <stop stop-color="#FFDD55" />
        <stop offset="0.1" stop-color="#FFDD55" />
        <stop offset="0.5" stop-color="#FF543E" />
        <stop offset="1" stop-color="#C837AB" />
      </radialGradient>
      <radialGradient id="paint1_radial_9975_53677" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(10.6975 12.9576) rotate(78.681) scale(4.18354 17.2447)">
        <stop stop-color="#3771C8" />
        <stop offset="0.128" stop-color="#3771C8" />
        <stop offset="1" stop-color="#6600FF" stop-opacity="0" />
      </radialGradient>
      <radialGradient id="paint2_radial_9975_53677" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(10.3611 33.3479) rotate(-90) scale(28.0771 26.114)">
        <stop stop-color="#FFDD55" />
        <stop offset="0.1" stop-color="#FFDD55" />
        <stop offset="0.5" stop-color="#FF543E" />
        <stop offset="1" stop-color="#C837AB" />
      </radialGradient>
      <radialGradient id="paint3_radial_9975_53677" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(-1.90945 4.87669) rotate(78.681) scale(12.5506 51.7341)">
        <stop stop-color="#3771C8" />
        <stop offset="0.128" stop-color="#3771C8" />
        <stop offset="1" stop-color="#6600FF" stop-opacity="0" />
      </radialGradient>
    </defs>
  </svg>
  <svg v-else xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" :opacity="opacity" :style="{ color: color }" viewBox="0 0 36 36" fill="none">
    <path
      d="M2.83203 16.9987C2.83203 11.7032 2.83203 9.05403 3.97103 7.08203C4.71703 5.78997 5.78997 4.71703 7.08203 3.97103C9.05403 2.83203 11.7032 2.83203 16.9987 2.83203C22.2942 2.83203 24.9434 2.83203 26.9154 3.97103C28.2074 4.71703 29.2804 5.78997 30.0264 7.08203C31.1654 9.05403 31.1654 11.7032 31.1654 16.9987C31.1654 22.2942 31.1654 24.9434 30.0264 26.9154C29.2804 28.2074 28.2074 29.2804 26.9154 30.0264C24.9434 31.1654 22.2956 31.1654 16.9987 31.1654C11.7018 31.1654 9.05403 31.1654 7.08203 30.0264C5.78997 29.2804 4.71703 28.2074 3.97103 26.9154C2.83203 24.9434 2.83203 22.2956 2.83203 16.9987Z"
      :stroke="color"
      stroke-width="2"
    />
    <path
      d="M25.1458 8.85156H25.1515V8.85723H25.1458V8.85156ZM23.375 16.9974C23.375 18.6882 22.7033 20.3097 21.5078 21.5052C20.3123 22.7007 18.6908 23.3724 17 23.3724C15.3092 23.3724 13.6877 22.7007 12.4922 21.5052C11.2967 20.3097 10.625 18.6882 10.625 16.9974C10.625 15.3066 11.2967 13.6851 12.4922 12.4896C13.6877 11.294 15.3092 10.6224 17 10.6224C18.6908 10.6224 20.3123 11.294 21.5078 12.4896C22.7033 13.6851 23.375 15.3066 23.375 16.9974Z"
      :stroke="color"
      stroke-width="2"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: 'InstagramIcon',
  props: {
    size: {
      type: [String, Number],
      default: 24,
    },
    color: {
      type: String,
      default: 'currentColor',
    },
    opacity: {
      type: [String, Number],
      default: 1,
    },
    isFill: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
